import React, { FC } from 'react';
import clsx from 'clsx';
import { ChatMessage } from '../ChatContent';
import styles from './ChatBubble.module.css';

const ChatBubble: FC<
  React.PropsWithChildren<{ author: ChatMessage['author'] }>
> = ({ author, children }) => {
  return (
    <div
      className={clsx({
        [styles.bubbleContainer]: true,
        [styles.narvarUser]: author === 'NARVAR',
      })}
    >
      <span
        className={clsx({
          [styles.chatBubble]: true,
          [styles.narvarUser]: author === 'NARVAR',
        })}
      >
        {children}
      </span>
    </div>
  );
};

export default ChatBubble;
